<template>
	<div class="app">
		<div class="brand-line"></div>
		<main class="mx-auto w-full max-w-[1440px] px-4 md:px-12">
			<nuxt />
		</main>
		<ToastContainerComponent />
		<client-only>
			<CookieBanner @open-settings="showCookieSettings = true" />
			<CookieSettingsModal
				v-if="showCookieSettings"
				@close="showCookieSettings = false"
			/>
		</client-only>

		<PortalTarget name="tooltip-root" multiple />
	</div>
</template>

<script>
import ToastContainerComponent from '~/components/toast-container'
import CookieBanner from '~/components/ui/banners/CookieBanner'
import CookieSettingsModal from '~/components/ui/modals/CookieSettingsModal'

export default {
	components: {
		ToastContainerComponent,
		CookieBanner,
		CookieSettingsModal
	},
	data() {
		return {
			showCookieSettings: false
		}
	},
	head() {
		return {
			meta: [{ hid: 'robots', name: 'robots', content: 'index, follow' }]
		}
	}
}
</script>
